import React from 'react'
import {GlobalContainer} from '../container/GlobalContainer'
import styled from '@emotion/styled'
import {TitleGradientHome} from '../title'
import {Text} from '../text'
import {keyframes} from '@emotion/core'
import ThinRectangle from '../../images/rectangle.inline.svg'
import {ButtonGradient} from '../buttons/button'
import {device} from '../../devices'


export const StartUpMentoring = ({intl}) => (
  <GlobalStartupsContainer>
    <GlobalContainer>
      <ContainerTitleRight>
        <TitleGradientHome>
          {intl.formatMessage({id: 'software_page.startup_mentoring.title'})}
        </TitleGradientHome>
      </ContainerTitleRight>

      <ContainerContent>
        <ContainerFancyBlock id="rectangle">
          <Rectangle>
            <TextContainerFancyBlock>
              <h3>
                <span role="img"
                      aria-label="light">💡</span> {intl.formatMessage({id: 'software_page.startup_mentoring.first_block_title'})}
              </h3>
              <Text>
                {intl.formatMessage({id: 'software_page.startup_mentoring.first_block_desc'})}
              </Text>
            </TextContainerFancyBlock>
          </Rectangle>
          <ThinRectangle/>

        </ContainerFancyBlock>
        <ContainerRightStartup data-sal="slide-up" data-sal-duration="1000" data-sal-easing="ease">
          <h3>
            <span role="img"
                  aria-label="hands-up">🙌</span> {intl.formatMessage({id: 'software_page.startup_mentoring.second_block_title'})}
          </h3>
          <Text>
            {intl.formatMessage({id: 'software_page.startup_mentoring.second_block_desc'})}
          </Text>
          <a href={`/en/#contact-us`}>
            <ButtonGradient>
              {intl.formatMessage({id: 'software_page.startup_mentoring.cta'})}
            </ButtonGradient>
          </a>
        </ContainerRightStartup>
      </ContainerContent>
    </GlobalContainer>
  </GlobalStartupsContainer>
)

const dash = keyframes`
  to {
    stroke-dashoffset: 2000;
  }
`

const ContainerRightStartup = styled.div`
  display: flex; 
  flex-direction: column;
  
  @media ${device.mobileL} {
    opacity: 1;
    transform: rotate(0deg);
    width: 100%;
  }
`
const ContainerContent = styled.div`
  display: flex;
  color: ${({theme: {black}}) => black};
  align-items: flex-start;
  justify-content: center;
  margin-top: 6vw;
  
  h3 {
    font-size: 2.7vw;
    font-weight: 600;
    margin: 10vw 0 0 0;
  }
  
  p {
    margin: 3.4vw 0 0 0;
    width: 30.078vw;
  }
  
  button {
    width: 23vw;
    margin-top: 2vw;
  }
  
  @media ${device.mobileL} {
    height: auto;
    align-items: center;
    flex-direction: column;
    margin-bottom:50px;
    text-align:center;
    
    button {
      width: auto;
      text-align:center;
      margin-top:40px;
    }
    
    h3 {
      font-size: 25px;
      text-align:center;
      width:100%;
    }
    
    p {
      font-size: 15px;
      width:100%;
      text-align:center;
    }
  }
`
const TextContainerFancyBlock = styled.div`
  transform: rotate(5deg);
  color: ${({theme: {white}}) => white};
  width: 27vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 0 0 2vw;
    
  h3 {
    font-size: 2.7vw;
    font-weight: 600;
    margin: 7vw 0 0 0;
  }
  
  p {
    margin: 3.4vw 0 0 0;
    font-size:1.3vw;
    width: 23vw;
  }
  
  @media ${device.mobileL} {
    width: 90%;
    transform: rotate(0deg);
    p {
      margin: 20px !important;
      font-size: 16px;
      width: 100% !important;
      text-align: center;
    }
    
    h3 {
      font-size: 25px;
    }
  }
`

const ContainerFancyBlock = styled.div`
  position: relative;
  width: 37.402vw;
  height: 43.750vw;
  display: flex;
  svg {
    width: 35vw;
    height: 39vw;
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
    position: absolute;
    top: -34px;
    left: -42px;
    z-index: -1;
    stroke-dasharray: 1000;
    animation: ${dash} 5s linear infinite;
    
    @media ${device.mobileL} {
      display: none;
    }
  }
  
  @media ${device.mobileL} {
    width: 100%;
    height: auto;
    
    h3 {
       width: 100%;
       text-align: center;
       font-size: 25px;
    }
  }
`

const Rectangle = styled.div`
  width: 30vw;
  height: 35vw;
  object-fit: contain;
  border-radius: 60px;
  z-index: 10;
  background: linear-gradient(#0accff, #66ffe5);
  transform: rotate(-5deg);
  position: absolute;
  left: 0vw;
  
  @media ${device.mobileL} {
    border-radius: 6vw;
    width: 100%;
    height: auto;
    position: relative;
    transform: rotate(0deg);
    margin: 0px 0 40px;
  }
`

const ContainerTitleRight = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  height: auto;
  margin: 8.7vw 0 0 0;
  
  h2 {
    margin-right: 10vw;
  }
  
  @media ${device.mobileL} {
    margin: 30px 0 40px;
    justify-content: center;
    h2 {
      margin-right: 0;
    }
  }
`

const GlobalStartupsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
  justify-content: flex-start;
  height: 68.359vw;
  @media ${device.mobileL} {
    height: auto;
    padding: 50px 0;

  }
`
